import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=2fd4c600"
import script from "./Initial.vue?vue&type=script&lang=js"
export * from "./Initial.vue?vue&type=script&lang=js"
import style0 from "./Initial.vue?vue&type=style&index=0&id=2fd4c600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports